export default function requestIdleCallback(fn, fallbackMs = 300) {
  if (process.client && typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(fn)
    return
  }
  setTimeout(fn, fallbackMs)
}
